import {
  usePatchWorkflow,
  useCreateWorkflow,
  useDeleteWorkflow,
  useTestWorkflow
} from '@/api/generated';

export const useWorkflow = () => {
  const { mutate: patchWorkflow, isPending: isPatchLoading } = usePatchWorkflow();
  const { mutate: createWorkflow, isPending: isCreateLoading } = useCreateWorkflow();
  const { mutate: deleteWorkflow } = useDeleteWorkflow();
  const { mutate: testWorkflow, isPending: isTestLoading } = useTestWorkflow();

  return {
    patchWorkflow,
    createWorkflow,
    deleteWorkflow,
    testWorkflow,
    isPatchLoading,
    isCreateLoading,
    isTestLoading
  };
};
